<template>
  <div class="sp-template">
    <div class="h-title">按客户统计信息</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryForm" class="header-search__form" size="small" label-width="90px">
          <el-row>
            <el-form-item label="类型" >   
                <el-select v-model="queryForm.timeType" >
                  <el-option v-for="(d, i) in timeTypes" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>        
            </el-form-item>
            <el-form-item label="客户">
              <el-select v-model="queryForm.orgOwner" clearable filterable placeholder="选择客户">
                <el-option v-for="(d, i) in customers" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道">
              <el-select v-model="queryForm.channelId" clearable filterable placeholder="选择渠道">
                <el-option v-for="(d, i) in channels" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="开始日期">
              <el-date-picker v-model.lazy="queryForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker v-model.lazy="queryForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
            </el-form-item>     
            <el-form-item label="截止日期" v-if="queryForm.timeType=='deliver'">
              <el-date-picker v-model.lazy="queryForm.cutoffDate" type="date" value-format="yyyy-MM-dd" placeholder="截止日期"></el-date-picker>
            </el-form-item> 
          </el-row> 

          <el-row>
            <el-form-item label="分公司" >   
                <el-select v-model="queryForm.companyId" clearable>
                  <el-option v-for="(d, i) in companys" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>        
            </el-form-item>            
          </el-row>

          <div class="search-form__buttons">
            <el-button  v-if="in_configs(80101)" type="primary" size="small" @click="searchTask()">搜 索</el-button>
            <el-button  v-if="in_configs(80101)" size="small" @click="reset()">清 空</el-button>
          </div>    
        </el-form>
      </div>
      <div class="table-button__groups">
        <div class="button-groups">
          <!-- <el-button v-if="in_configs(80102)" size="small" @click="exportExcel(1)">导出当前页</el-button> -->
          <el-button v-if="in_configs(80103)" size="small" @click="exportExcel(2)">导出全部</el-button>
        </div>
      </div>
      <el-table :data="tableData" stripe border style="width: 100%">
        <el-table-column label="客户">
          <template slot-scope="scope">
            {{customerMaps[scope.row.customerId]}}
          </template>
        </el-table-column>
        <el-table-column label="分公司">
          <template slot-scope="scope">
            {{companyMap[scope.row.companyId]}}
          </template>
        </el-table-column>
        <el-table-column label="渠道">
          <template slot-scope="scope">
            {{channelsMaps[scope.row.productId]}}
          </template>
        </el-table-column>
        <el-table-column prop="orderCount" label="订单量" width="120"></el-table-column>
        <el-table-column prop="billedWeight" label="计费重(KG)" width="120"></el-table-column>
        <el-table-column prop="packageQty" label="包裹数量" width="120"></el-table-column>
        <el-table-column prop="totalWeight" label="总重量(KG)" width="120"></el-table-column>
        <el-table-column prop="amount" label="销售额(元)" show-overflow-tooltip></el-table-column>
        <el-table-column prop="estimateAmount" label="成本总金额(元)" show-overflow-tooltip></el-table-column>
        <el-table-column prop="costAmount" label="财务成本总金额(元)" show-overflow-tooltip></el-table-column>
        <el-table-column prop="profit" label="利润(元)" show-overflow-tooltip></el-table-column>
      </el-table>
      <el-table :data="tongjiData" stripe tooltip-effect="dark" style="width: 100%" >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column label="">
          <template slot-scope="scope">
            合计：
          </template>
        </el-table-column>
        <el-table-column label="">
          <template slot-scope="scope">
            
          </template>
        </el-table-column>
         <el-table-column prop="orderCount" label="" width="120"></el-table-column>
        <el-table-column prop="billedWeight" label="" width="120"></el-table-column>
        <el-table-column prop="packageQty" label="" width="120"></el-table-column>
        <el-table-column prop="totalWeight" label="" width="120"></el-table-column>
        <el-table-column prop="amount" label="" show-overflow-tooltip></el-table-column>
        <el-table-column prop="estimateAmount" label="" show-overflow-tooltip></el-table-column>
        <el-table-column prop="costAmount" label="" show-overflow-tooltip></el-table-column>
        <el-table-column prop="profit" label="" show-overflow-tooltip></el-table-column>
       
        
      </el-table>
      

      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryForm.currentPage" :page-sizes="pageSizes" :page-size="queryForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>

    </el-card>
    <form action="" method="get" target="_blank" id="myform">
      </form>

    <!-- Form -->
    <el-dialog title="完成" :visible.sync="dialogFormVisible">
      <el-form>
        <el-form-item label="提货箱数">
          <el-input v-model="cartonQty" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDone()">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'

export default {
  data() {
    return {
      queryForm: {
        orgOwner: "",
        channelId: "",
        startDate: "",
        endDate: "",
        cutoffDate: "",
        export: 0,
        timeType: "deliver",
        pageSize: 10,
        currentPage: 1,
        companyId: ""
      },
      customers: [],
      customerMaps: {},
      channels: [],
      channelsMaps: {},

      orderCount: 0,
      billedWeight: 0,
      packageQty: 0,
      totalWeight: 0,
      amount: 0,
      costAmount: 0,
      profit: 0,
      tongjiData: [],

      status: "未处理",
      searchData: {
        //搜索数据
        statu: "",
        product: "",
        number: "",
        startDate: "",
        endDate: ""
      },
      tableData: [],
      drivers: [],
      vehicles: [],
      driversMap: {},
      vehiclesMap: {},
      dialogFormVisible: false,
      cartonQty: 0,
      orderId: "",
      timeTypes: [
        { id: "charge", name: "扣费时间" },
        { id: "deliver", name: "发货时间" }
      ],

      //分页的数据
      pageSizes: [10, 20, 50, 100],
      total: 0,
      companys: [],
      companyMap: {}
    };
  },
  created() {
    //this.findAllChannle();
    //this.findByCustomerName();
    setTimeout(() => {
      var _this = this;
      let urlArray = [this.findAllCustomerName(), this.findAllChannle()];
      this.$axios.all(urlArray).then(
        this.$axios.spread(function(customerData, channelData) {
          _this.initCustomerData(customerData);
          _this.initChannelData(channelData);

          _this.queryForm.startDate = _this.getLastMonth();
          _this.queryForm.endDate = _this.getTheMonth();
          _this.queryForm.cutoffDate = _this.formatDate(
            new Date(),
            "yyyy-MM-dd"
          );
          _this.queryOrder();
        })
      );

      this.queryCompany();
      
    }, 1000);
  },
  computed: {
    configs() {
      return JSON.parse(sessionStorage.configs);
    }
  },
  methods: {
    getLastMonth() {
      var nowdate = new Date();
      nowdate.setDate(1);
      nowdate.setMonth(nowdate.getMonth() - 1);
      return this.formatDate(nowdate, "yyyy-MM-dd");
    },
    getTheMonth() {
      var nowdate = new Date();
      nowdate.setDate(0);
      return this.formatDate(nowdate, "yyyy-MM-dd");
    },
    //查询渠道
    findAllChannle() {
      return this.$request1.get(
        '/system/channel/all' + "?needStatus=no&needOpen=no"
      );
    },
    //查询客户
    findAllCustomerName() {
      return this.$request1.get(
        '/customerAll'
      );
    },
    initChannelData(data) {
      let _this = this;
      _this.channels = data.data;
      if (_this.channels.length > 0) {
        _this.channels.forEach(c => {
          _this.channelsMaps[c.id] = c.name;
        });
      }
    },
    initCustomerData(data) {
      let _this = this;
      if (data.data.success) {
        _this.customers = data.data.data;
        if (_this.customers.length > 0) {
          _this.customers.forEach(c => {
            _this.customerMaps[c.id] = c.name;
          });
        }
      }
    },
    //查询客户
    findByCustomerName() {
      let _this = this;
      this.$request1
        .get(
          '/customerAll',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            _this.customers = res.data.data;
            if (_this.customers.length > 0) {
              _this.customers.forEach(c => {
                _this.customerMaps[c.id] = c.name;
              });
            }
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    queryCompany(){
        let _this = this;
        this.$request1({
            method: 'get',
            url: '/system/company',
            params: {
              page:  1,
              pageSize: -1
            }
        })
        .then(response => {          
            _this.companys = response.data.data;
            _this.companys.forEach(a => {
                _this.companyMap[a.id] = a.name;
            });
        })
        .catch(error => {
          console.log(error);
        });
    },
    //搜索
    searchTask() {
      this.queryForm.currentPage = 1;
      this.queryOrder();
      //console.log("搜索");
    },
    reset() {
      this.queryForm = {
        orgOwner: "",
        channelId: "",
        startDate: "",
        endDate: "",
        cutoffDate: "",
        export: 0,
        timeType: "deliver",
        pageSize: 10,
        currentPage: 1,
        companyId: ""
      };
      this.searchTask();
    },
    //编辑
    handleEdit(index, row) {
      row.assign = false;
      //console.log(index, row);
    },
    //分页
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.queryForm.currentPage = 1;
      this.queryForm.pageSize = val;
      this.queryOrder();
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      console.log(`当前页: ${val}`);
      this.queryForm.currentPage = val;
      this.queryOrder();
    },
    queryOrder() {
      let _this = this;
      _this.queryForm.export = 0;
      this.$request1
        .post(
          '/report/customer',
          _this.queryForm,
          {
            
            timeout: 10000,
            withCredentials: true,
            // headers: {
            //   "content-type": "application/x-www-form-urlencoded"
            // }
          }
        )
        .then(function(response) {
          _this.tableData = response.data.data.list;
          _this.total = response.data.total;

          _this.orderCount = response.data.data.orderCount;
          _this.billedWeight = response.data.data.billedWeight;
          _this.packageQty = response.data.data.packageQty;
          _this.totalWeight = response.data.data.totalWeight;
          _this.amount = response.data.data.amount;
          _this.costAmount = response.data.data.costAmount;
          _this.estimateAmount = response.data.data.estimateAmount;
          _this.profit = response.data.data.profit;
          _this.tongjiData = [
            {
              orderCount: _this.orderCount,
              billedWeight: _this.billedWeight,
              packageQty: _this.packageQty,
              totalWeight: _this.totalWeight,
              amount: _this.amount,
              costAmount: _this.costAmount,
              estimateAmount: _this.estimateAmount,
              profit: _this.profit
            }
          ];
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    exportExcel(val) {
      let _this = this;
      _this.queryForm.export = val;

      this.$request1({
          url: '/report/customer',
          method: 'post',
          data: this.queryForm,
          responseType: 'blob'
        }).then(res => {
          _this.queryForm.export = 0
          const link = document.createElement('a')
          // let array = base64ToUint8Array(res.data)
          // let blob = new Blob([array])
          let blob = new Blob([res.data])
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
          link.setAttribute('download', `customer_${timestr}.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })



      // var url = tmsSpringUrl + '/report/customer';
      // var form = document.getElementById("myform");
      // form.setAttribute("action", url);
      // var fhtml = "";
      // for (var key in _this.queryForm) {
      //   fhtml +=
      //     '<input type="hidden" name="' +
      //     key +
      //     '" value="' +
      //     (_this.queryForm[key] == null ? "" : _this.queryForm[key]) +
      //     '" />';
      // }
      // fhtml +=
      //   '<input type="hidden" name="token" value="' +
      //   this.$getToken() +
      //   '" />';
      // form.innerHTML = fhtml;
      // form.submit();
    },
    formatDate(date, fmt) {
      if (!date) {
        return "";
      }
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      var week = {
        "0": "/u65e5",
        "1": "/u4e00",
        "2": "/u4e8c",
        "3": "/u4e09",
        "4": "/u56db",
        "5": "/u4e94",
        "6": "/u516d"
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (RegExp.$1.length > 1
            ? RegExp.$1.length > 2
              ? "/u661f/u671f"
              : "/u5468"
            : "") + week[date.getDay() + ""]
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    }
  }
};
//function formatDate(date,fmt){if(!date){return""}var o={"M+":date.getMonth()+1,"d+":date.getDate(),"h+":date.getHours()%12==0?12:date.getHours()%12,"H+":date.getHours(),"m+":date.getMinutes(),"s+":date.getSeconds(),"q+":Math.floor((date.getMonth()+3)/3),"S":date.getMilliseconds()};var week={"0":"/u65e5","1":"/u4e00","2":"/u4e8c","3":"/u4e09","4":"/u56db","5":"/u4e94","6":"/u516d"};if(/(y+)/.test(fmt)){fmt=fmt.replace(RegExp.$1,(date.getFullYear()+"").substr(4-RegExp.$1.length))}if(/(E+)/.test(fmt)){fmt=fmt.replace(RegExp.$1,((RegExp.$1.length>1)?(RegExp.$1.length>2?"/u661f/u671f":"/u5468"):"")+week[date.getDay()+""])}for(var k in o){if(new RegExp("("+k+")").test(fmt)){fmt=fmt.replace(RegExp.$1,(RegExp.$1.length==1)?(o[k]):(("00"+o[k]).substr((""+o[k]).length)))}}return fmt};
</script>

<style lang="scss" scoped>
.el-card__header .el-form .el-input {
  width: 205px;
}
</style>


// WEBPACK FOOTER //
// src/views/report/customer.vue